import { useMemo } from "../../../__compat__/react/main.entry.mjs.mjs";
import { range } from "../../../__compat__/lodash/main.entry.mjs.mjs";
import { addDays, startOfWeek } from "../../../__compat__/date-fns/main.entry.mjs.mjs";
import { useLocale } from "../../LocaleProvider/index.mjs.mjs";
export const useLocalizedWeekdays = () => {
    const { localeIdentifier, datePicker: locale } = useLocale();
    const { format } = useMemo(() => new Intl.DateTimeFormat(locale.dateLocale || localeIdentifier, {
        weekday: 'short',
    }), [localeIdentifier, locale.dateLocale]);
    const weekdays = useMemo(() => {
        return range(7)
            .map((index) => addDays(startOfWeek(new Date(), {
            weekStartsOn: locale.weekStartsOn,
        }), index))
            .map((date) => format(date));
    }, [format, locale.weekStartsOn]);
    return {
        weekdays,
        getDay: format,
    };
};
//# sourceMappingURL=useLocalizedWeekdays.mjs.mjs.map